import { render, staticRenderFns } from "./CustomClient.vue?vue&type=template&id=5b68d872"
import script from "./CustomClient.vue?vue&type=script&lang=js"
export * from "./CustomClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports